    const serviceCenters = [
   {
    "Postal_Pincode":[{"zipcode":"380015,	382350,	380013,	380058,	382481,	380001,	382415,	382345,	380026,	382330,	382424,	382418,	382405,	380009,	380061,	380051,	380054,	382480,	380008,	380050,	380007,	380055,	380016,	380052,	382445,	380005,	380024,	380004,	380006,	380060,	380028,	380022,	380059,	382443,	380018,	382110,	382470,	382210,	380021,	382449,	382220,	382475,	380023,	382340,	382213,	382150,	382440,	382460,	380063,	382430,	380014,	382225,	382427,	382425,	382435,	382170,	380019,	380027,	383345,	382115,	382230,	382260,	382265,	380002,	382240,	382455,	382465"}],
    "State":"Gujarat",
    "City":"Ahmedabad",
    "Store_name":"F1 - Ahmedabad-Multibrand",
    "SVC_Address":"102, Santorini Square Bldg, Opp. Star Bazar, Jodhpur, Satelite, Ahmedabad-380015",
    "Latitude":"23.02490324",
    "Longitude":"72.52331089",
    "Contact_Number":"079-40190136 | 079-40190136",
    "Customer_visiting_Timings":"10:00 AM - 06:00 PM"
  },
  {
    "Postal_Pincode":[{"zipcode":"600018,	600020,	600082,	600029,	600040,	600102,	600101,	600002,	600106,	600083,	600023,	600090,	600108,	600021,	600113,	600100,	600115,	600122,	600126,	600130,	602028,	603210,	600032,	600001,	600005,	600031,	600112,	600094,	600012,	600025,	600003,	600008,	600118,	600084,	600028,	600009,	600014,	600086,	600006,	600015,	600104,	600017,	600038,	600036,	600078,	600013,	600024,	600010,	600085,	600107,	600092,	600033,	600034,	600004,	600079,	600035,	600030,	600011,	600022,	600093,	600041,	600081,	600026,	600007,	600039,	600123,	600124,	600125,	600127,	600128,	600129,	602004,	602102,	602104,	600042,	607006"}],
    "State":"Tamil Nadu",
    "City":"Chennai",
    "Store_name":"S K Info Systems",
    "SVC_Address":"SHOP NO 34, 1ST FLOOR J J COMPLEX, THIRUMANGALAM, ANNA NAGAR, Chennai - 600040",
    "Latitude":"13.08659",
    "Longitude":"80.1983",
    "Contact_Number":"044 42147333",
    "Customer_visiting_Timings":"10:00 AM - 06:00 PM"
  },
  {
    "Postal_Pincode":[{"zipcode":"560026,	560026,	560026,	560086,	560070,	560073,	560053,	560085,	560044,	560057,	560004,	560079,	560056,	560018,	560040,	560062,	560019,	560022,	560013,	560104,	560014,	560015,	560023,	560072,	560039,	560059,	560028,	560091,	562162,	560109,	571493,	626706,	635125,	600111,	560063,	560030,	560034,	560007,	560092,	560024,	562106,	560045,	560003,	562107,	560064,	560106,	560047,	560002,	562149,	560043,	560017,	560001,	560009,	560300,	560025,	560083,	560076,	560103,	560046,	562157,	560010,	560049,	560068,	562158,	560093,	560097,	560061,	562130,	560067,	560036,	560029,	560037,	560071,	562125,	560016,	560100,	560005,	560065,	560021,	560087,	560008,	560051,	560031,	560048,	560102,	560066,	560038,	560094,	560078,	560006,	560041,	560069,	560011,	560105,	560020,	560084,	560096,	560098,	560095,	560077,	560074,	560054,	560033,	560055,	560099,	560075,	560032,	560058,	560080,	560027,	560012,	560042,	560052,	560050"}],
    "State":"Karnataka",
    "City":"Bangaluru",
    "Store_name":"M A Technologies",
    "SVC_Address":"No 2/3, 1St Floor, 3Rd Main Road, K.H.M Block, Ganga Nagar, R.T. Nagar, Bangalore, Karnataka-560032",
    "Latitude":"13.02276",
    "Longitude":"77.59228",
    "Contact_Number":"9845675386",
    "Customer_visiting_Timings":"10:00 AM - 06:00 PM"
  },
  {
    "Postal_Pincode":[{"zipcode":"462001,	462022,	462023,	462003,	462010,	462016,	462042,	462026,	462008,	462043,	462039,	462030,	462041,	462037,	462038,	462046,	462036,	462024,	462002,	462004,	462047,	463106,	462044,	462045,	462027"}],
    "State":"Madhya Pradesh",
    "City":"Bhopal",
    "Store_name":"Techmate Enterprises",
    "SVC_Address":"Plot No. 75, First Floor, M.P.Nagar, Zone-2, Bhopal- 462011",
    "Latitude":"23.23190927",
    "Longitude":"77.43556655",
    "Contact_Number":"07554248888 | 9977998888",
    "Customer_visiting_Timings":"10:00 AM - 06:00 PM"
  },

  {
    "Postal_Pincode":[{"zipcode":"682024,	682030,	682018,	682021,	683101,	682019,	682301,	683511,	682016,	682025,	682307,	683112,	682004,	682017,	682020,	682001,	683556,	682507,	682035,	682032,	682041,	682508,	683544,	682304,	682028,	683517,	683562,	683565,	683513,	683572,	682315,	682037,	683110,	683561,	683520,	682311,	683503,	683102,	682040,	682007,	682006,	682013,	683574,	686662,	683546,	683106,	683581,	683105,	682012,	682010,	682011,	682034,	682026,	682314,	682506,	683501,	682305,	683542,	682306,	682015,	682027,	683580,	683578,	683550,	682312,	682504,	683563,	683589,	682309,	683518,	683575,	683104,	682505,	682005,	682022,	683108,	682308,	682509,	683515,	683585,	686663,	686664,	683571,	682042,	683519,	683514,	682511,	683522,	682503,	682023,	682002,	682033,	682036,	682003,	682031,	683576,	682303,	683547,	682302,	683594,	683573,	683111,	683577,	683543,	683579,	683512,	682038,	682029"}],
    "State":"Kerala",
    "City":"Cochin",
    "Store_name":"Zinage systems",
    "SVC_Address":"Opp Sangeeth Mahal Musicals,Revipuram, Cochin-682016",
    "Latitude":"9.960643056",
    "Longitude":"76.28994189",
    "Contact_Number":"0484-4061211 | 0484-4061211",
    "Customer_visiting_Timings":"10:00 AM - 06:00 PM"
  },

  {
    "Postal_Pincode":[{"zipcode":"500030,	500004,	500045,	500007,	500012,	500015,	500044,	500013,	501301,	500040,	500020,	500048,	500058,	500064,	500005,	500034,	500027,	500016,	500003,	500018,	500080,	500039,	500022,	500024,	500081,	500008,	500028,	500006,	500060,	500062,	500053,	500065,	500029,	500001,	500068,	500052,	500066,	500025,	500051,	500035,	500046,	500089,	500090,	500091,	500096,	500002,	500076,	500082,	500031,	500079,	500085,	500033,	500077,	500067,	500074,	500017,	500063,	500036,	500026,	500095,	500069,	500071,	500041,	500023,	500059,	500038,	500061,	500073,	500070,	500057,	501101,	585247,	500101,	501102,	502305,	502279,	502285,	502205,	502313,	509325,	509228,	500030,	500004,	500045,	500007,	500012,	500015,	500044,	500013,	501301,	500040,	500020,	500048,	500058,	500064,	500005,	500034,	500027,	500016,	500003,	500018,	500080,	500039,	500022,	500024,	500081,	500008,	500028,	500006,	500060,	500062,	500053,	500065,	500029,	500001,	500068,	500052,	500066,	500025,	500051,	500035,	500046,	500089,	500090,	500091,	500096,	500002,	500076,	500082,	500031,	500079,	500085,	500033,	500077,	500067,	500074,	500017,	500063,	500036,	500026,	500095,	500069,	500071,	500041,	500023,	500059,	500038,	500061,	500073,	500070,	500057,	502032,	502325,	502319,	502307,	502300,	502324,	502329,	502336,	501510,	500014,	501506,	500043,	500087,	501503,	500010,	501504,	501512,	500047,	501508,	500075,	500037,	501505,	501203,	500011,	500050,	501218,	500032,	501323,	500042,	500054,	500055,	501511,	500084,	500072,	500019,	500009,	501401,	500049,	500083,	500056,	500078,	500094,	500093,	500097,	585247,	500092,	509002,	500101"}],
    "State":"Telangana",
    "City":"Hyderabad",
    "Store_name":"Lotus Technology",
    "SVC_Address":"Ist Floor 5-9-88/4/A, AAK Complex, Fathemaidan, ABIDS, Hyderabad, Telangana, 500001",
    "Latitude":"17.3935",
    "Longitude":"78.47067",
    "Contact_Number":"9063593210",
    "Customer_visiting_Timings":"10:00 AM - 06:00 PM"
  },

  {
    "Postal_Pincode":[{"zipcode":"452016,	452006,	453441,	452020,	452012,	452005,	453331,	453771,	452007,	453001,	453115,	453112,	453555,	453332,	453446,	453551,	453661,	453111,	453220,	453556"}],
    "State":"Madhya Pradesh",
    "City":"Indore",
    "Store_name":"F1 - Indore- Multibrand",
    "SVC_Address":"108A, 107A & B, Mangal City Mall, PU4, Plot No. 1, Vijaynagar, AB Road, Indore-452010",
    "Latitude":"22.75249479",
    "Longitude":"75.89629736",
    "Contact_Number":"0731-4095217",
    "Customer_visiting_Timings":"10:00 AM - 06:00 PM"
  },

  {
    "Postal_Pincode":[{"zipcode":"302012,	302015,	302017,	302020,	302019,	302018,	302021,	302033,	302006,	302001,	302016,	302013,	302029,	302004,	302002,	302003,	302022,	303108,	302028,	302026,	303702,	303012,	303007,	303103,	302027,	303905,	303104,	303712,	303121,	303106,	303002,	303328,	303008,	303001,	303338,	302005,	303006,	303704,	303120,	303301,	303807,	303804,	303107,	303801,	303603,	303904,	303122,	303102,	303305,	303009,	303805,	303701,	303901,	303706,	303604"}],
    "State":"Rajasthan",
    "City":"Jaipur",
    "Store_name":"Care Solutions",
    "SVC_Address":"Plot #7A, 1St Floor, Scheme - 1, Tejaji Marg, Opposite Metro Pillar 120, New Sanganer Road, Near Sodala",
    "Latitude":"26.89826949",
    "Longitude":"75.77145117",
    "Contact_Number":"9799338888",
    "Customer_visiting_Timings":"10:00 AM - 06:00 PM"
  },

  {
    "Postal_Pincode":[{"zipcode":"208001,	208017,	208027,	208021,	208011,	208025,	208020,	208007,	208002,	208024,	208014,	208005,	208004,	208013,	208012,	208019,	208022,	208010,	208016,	208023,	209305,	208006,	209217,	208008,	208015,	208003,	208009,	208026,	209402,	209304,	209214,	209203"}],
    "State":"Uttar Pradesh",
    "City":"Kanpur Nagar",
    "Store_name":"Sipl",
    "SVC_Address":"124/V/18 Govind Nagar , Opposite Jai Sweet House , Kanpur, Uttar Pradesh - 208006",
    "Latitude":"26.44924",
    "Longitude":"80.31237",
    "Contact_Number":"7393805005",
    "Customer_visiting_Timings":"10:00 AM - 06:00 PM"
  },

  {
    "Postal_Pincode":[{"zipcode":"700020,	700046,	700014,	700086,	700019,	700010,	700054,	700042,	700012,	700073,	700017,	700031,	700032,	700029,	700107,	700016,	700047,	700075,	700095,	700078,	700033,	700068,	700085,	700063,	700099,	700058,	700076,	700079,	700081,	700083,	700159,	700160,	743387,	743437,	700011,	700094,	700009,	700092,	700015,	712419,	712401,	712706,	712250,	712248,	712246,	712232,	712204,	712235,	712233,	712704,	712245,	712249,	712258,	712411,	712701,	712301,	712409,	712223,	712424,	712405,	712203,	712222,	712407,	712304,	712306,	712403,	712124,	712310,	712702,	712102,	712311,	712408,	712707,	712138,	712234,	712705,	712139,	712247,	711205,	711201,	711403,	711104,	711101,	711106,	711322,	711102,	711204,	711302,	711109,	711103,	711411,	711202,	711227,	711310,	711105,	711107,	711409,	711203,	711414,	711110,	711112,	711313,	711114,	711226,	711405,	711408,	711410,	711309"}],
    "State":"West Bengal",
    "City":"Kolkata",
    "Store_name":"F1-Kolkata",
    "SVC_Address":"2, Raja Subodh Mullick Square,Near-Hind Inox 1st floor Kolkata - 700013. India.",
    "Latitude":"22.56483242",
    "Longitude":"88.35986166",
    "Contact_Number":"033-40633619|033-40066347",
    "Customer_visiting_Timings":"10:00 AM - 06:00 PM"
  },
  {
    "Postal_Pincode":[{"zipcode":"226010,	226016,	226020,	226003,	226021,	226001,	226002,	226028,	226022,	226017,	226005,	226012,	226024,	226018,	226006,	226025,	226008,	226023,	226004,	226026,	226101,	226013,	226301,	226201,	226015,	226401,	226501,	226202,	226009,	226203,	226103,	226102,	226104,	226302,	226019"}],
    "State":"Uttar Pradesh",
    "City":"Lucknow",
    "Store_name":"F1 - Lucknow-Multibrand",
    "SVC_Address":"Show Room No.- B, Lower Ground Floor, Burlington Arcade, Vidhan Sabha Marg, Lucknow, Uttar Pradesh, 226001",
    "Latitude":"26.84114168",
    "Longitude":"80.93762027",
    "Contact_Number":"0522-4959505 | 0522-4959505 | 0522-4951704",
    "Customer_visiting_Timings":"10:00 AM - 06:00 PM"
  },
  {
    "Postal_Pincode":[{"zipcode":"400069,	400058,	400059,	400060,	400086,	400013,	400601,	400610,	400608,	400606,	400605,	400612,	400602,	400607,	400603,	421201,	421202,	400604,	400091,	400066,	400092,	400071,	400014,	400017,	400086,	400063,	400007,	400060,	400102,	400101,	400067,	400070,	400097,	400064,	400006,	400008,	400079,	400031,	400018,	400030,	401107,	402103,	400022,	400037,	400024"}],
    "State":"Maharashtra",
    "City":"Mumbai",
    "Store_name":"Today Telecom",
    "SVC_Address":"B21-22, Orbit Grand, Opp. BMC C South Ward, Near Deepak Cinema, NM Joshi Marg , Prabhadevi West, ( Elphostone ) Mumbai, 400013",
    "Latitude":"19.076",
    "Longitude":"72.87766",
    "Contact_Number":"9702787205",
    "Customer_visiting_Timings":"10:00 AM - 06:00 PM"
  },

      
  {
    "Postal_Pincode":[{"zipcode":"440034,	440024,	440008,	440027,	440002,	440018,	440017,	440035,	440032,	440036,	440003,	440037,	441201,	441204,	440007,	441214,"}],
    "State":"Maharashtra",
    "City":"Nagpur",
    "Store_name":"F1 - Nagpur- Multibrand",
    "SVC_Address":"FS-019, 1st Flr Keshav Imperial, Malviya Road, Sitabuldi, Nagpur-440012",
    "Latitude":"21.14332157",
    "Longitude":"79.08722135",
    "Contact_Number":"0712-2557288",
    "Customer_visiting_Timings":"10:00 AM - 06:00 PM"
  },

  {
    "Postal_Pincode":[{"zipcode":"201301,	201309,	201313,	201310,	203207,	201306,	201304,	201305,	201301,	201301,	201301,	201301,	201303,	201307,	201303,	201303,	201307,	201309,	201008"}],
    "State":"Uttar Pradesh",
    "City":"Noida",
    "Store_name":"Sai Saavi Prime Electronics Pvt Ltd",
    "SVC_Address":"Shop No: 46, 2nd Floor, Wave Mall, Sector 18 Noida, (U.P) - 201301",
    "Latitude":"18.5036",
    "Longitude":"73.92551",
    "Contact_Number":"9540525836",
    "Customer_visiting_Timings":"10:00 AM - 06:00 PM"
  },
  {
    "Postal_Pincode":[{"zipcode":"800001,	800006,	800020,	801503,	800004,	800007,	800002,	800026,	800008,	800014,	800023,	800003,	800016,	800024,	800027,	800013,	801105,	801103,	800011,	800010,	800009,	803201,	800025,	803212,	804452,	801506,	803202,	801507,	800018,	801113,	801108,	801111,	803211,	801112,	804451,	800019,	800015,	801304,	800029,	800017,	804454"}],
    "State":"Bihar",
    "City":"Patna",
    "Store_name":"Mahi SVC",
    "SVC_Address":"2ND FLOOR, FLAT NO. 202 B, SAROJ TOWER, JAMAL ROAD,PATNA, Patna Bihar - 800001",
    "Latitude":"25.60660569",
    "Longitude":"85.13995168",
    "Contact_Number":"8102313841 | 8102313841",
    "Customer_visiting_Timings":"10:00 AM - 06:00 PM"
  },
  {
    "Postal_Pincode":[{"zipcode":"411040,411032,412206,	411046,	412212,	412207,	412209,	412301,	412202,	411001,	411014,	412102,	411028,	411013,	411048,	412307,	411036,	412308,	411060,	412204,	413102,	413133,	413801,	412203,	413130,	413105,	412208,	412210,	413802,	411033,	410501,	411057,	412105,	411015,	411045,	411021,	411027,	410507,	411039,	411019,	412101,	411006,	411018,	411017,	411047,	411026,	410401,	411035,	412216,	412109,	410505,	411016,	410405,	411007,	412412,	410503,	411012,	411003,	412201,	411031,	412220,	412205,	413104,	411020,	411034,	413115,	413110,	412219,	410301,	410402"}],
    "State":"Maharashtra",
    "City":"Pune",
    "Store_name":"SAI ENTERPRISES - HADAPSAR",
    "SVC_Address":"Sr.No.162/1/2/3 Office No 14, Aryan Center 1st Floor Above Axis bank Pune-Solapur Road, Hadapsar - 411028",
    "Latitude":"18.4988",
    "Longitude":"73.9543",
    "Contact_Number":"9209239515",
    "Customer_visiting_Timings":"10:00 AM - 06:00 PM"
  },

  {
    "Postal_Pincode":[{"zipcode":"396193,	396240,	396210,	396215,	395006,	394210,	395004,	395010,	395002,	394221,	394230,	394101,	395001,	394510,	394601,	394105,	395023,	394650,	394185,	394305,	394130,	394327,	394325,	394326,	394190,	394180,	394310,	394670,	394315,	394550,	394125,	394170,	394160,	394540,	394660,	394440,	394515,	394360,	394405,	394335,	394340,	394370,	394375,	394317,	394430,	394517,	394520,	394155,	395011,	395012"}],
    "State":"Gujarat",
    "City":"Surat",
    "Store_name":"The Sun Technology.",
    "SVC_Address":"Sun Technologies, 8,1St Floor Dutch House, Dutch Road, Surat",
    "Latitude":"21.19152776",
    "Longitude":"72.81498869",
    "Contact_Number":"7984425668",
    "Customer_visiting_Timings":"10:00 AM - 06:00 PM"
  },


  {
    "Postal_Pincode":[{"zipcode":"221005,221001,221010,221002,221007,221003,221008,221106,221011,221004,221108,221107,221311,221104,221103,221307,221101,221208,221105,221202,221206,232107,221006,221204,221112,221305,232103,221302,221110,221403,221405,221306,232106,221201,232110,221115,221116"}],
    "State":"Uttar Pradesh",
    "City":"VARANASI",
    "Store_name":"SIDDHANT COMMUNICATION",
    "SVC_Address":"D58/2-A Bhawani Market Near Kuber complex Rathaytra",
    "Latitude":"25.30705868",
    "Longitude":"82.99937982",
    "Contact_Number":"8858167462",
    "Customer_visiting_Timings":"10:00 AM - 06:00 PM"
  },
  {
    "Postal_Pincode":[{"zipcode":"520001,	520010,	520007,	520012,	520002,	520015,	521001,	520011,	520003,	521108,	520013,	520004,	521101,	520008,	521137,	521456,	521175,	521201,	521105,	521165,	521002,	521228,	521301,	521110,	521104,	521212,	521241,	521151,	521230,	521185,	521121,	521245,	521366,	521343,	521333,	521344,	521111,	521133,	521139,	521181,	521225,	521235,	521286,	521126,	521211,	521131,	521190,	521102,	521149,	521180,	521182,	521256,	521260,	521109,	521325,	521326,	521130,	521327,	521328,	521331,	521332,	521390,	521403,	521229"}],
    "State":"Andhra Pradesh",
    "City":"Vijayawada",
    "Store_name":"M and M Technologies",
    "SVC_Address":"28-1-38.first floor,eluru road, Near Sonovision, Vijayawada-520002",
    "Latitude":"16.51404441",
    "Longitude":"80.62914592",
    "Contact_Number":"0866-6679396 | 8008882884",
    "Customer_visiting_Timings":"10:00 AM - 06:00 PM"
  },



  {
    "Postal_Pincode":[{"zipcode":"530016,	530026,	530046,	530001,	530017,	530012,	530018,	530007,	530011,	530008,	531173,	530013,	530048,	530044,	530051,	530002,	531001,	530027,	530040,	530009,	530004,	530032,	530003,	530041,	531163,	530045,	531055,	530022,	530020,	530047,	530024,	531126,	531162,	530014,	530029,	531032,	531002,	531019,	531021,	531116,	530005,	531011,	530028,	531035,	531031,	531113,	531085,	530031,	531033,	535145,	530043,	531083,	531084,	531114,	531081,	531061,	531020,	531025,	531117,	531026,	531028,	531022,	531036,	531115,	530052,	531040,	530049,	531219,	531082,	530015,	531060,	531149"}],
    "State":"Andhra Pradesh",
    "City":"Visakhapatnam",
    "Store_name":"Ssv Technologies",
    "SVC_Address":"Shop no- G-8,Ground Floor,The Land Mark Compelex, Opp to Kalyan jewlers,Waltair Uplands,Sampath Vinayaka Temple Road, Vishakapatnam",
    "Latitude":"17.72759",
    "Longitude":"83.30441",
    "Contact_Number":"9290730559 / 9885835809",
    "Customer_visiting_Timings":"10:00 AM - 06:00 PM"
  },


  {
    "Postal_Pincode":[{"zipcode":"160036,	160047,	160101,	160022,	160019,	160002,	160030,	160020,	160012,	160003,	160009,	160015,	160102,	160025,	160017,	160023,	160011,	160001,	160018,	140125,	160004,	140119"}],
    "State":"Chandigarh",
    "City":"Chandigarh",
    "Store_name":"F1 - Chandigarh-Multibrand",
    "SVC_Address":"SCO No. - 817-818,1st Floor, Sector 22 A Chandigarh-160022",
    "Latitude":"30.7384327",
    "Longitude":"76.77485139",
    "Contact_Number":"0172-4061342",
    "Customer_visiting_Timings":"10:00 AM - 06:00 PM"
  },

  {
    "Postal_Pincode":[{"zipcode":"141001,	141003,	141008,	141010,	141007,	141015,	141016,	141002,	141012,	141014,	141114,	141401,	141013,	141120,	142026,	141006,	141116,	141106,	141115,	141123,	141104,	142021,	142022,	141102,	141416,	141112,	142023,	141004,	141110,	141119,	141118,	142029,	141418,	141017,	141205,	141113,	142032,	141203,	142027,	141413,	141122,	142033,	142035,	141107,	142025,	141414"}],
    "State":"Punjab",
    "City":"Ludhiana",
    "Store_name":"F1 - Ludhiana-Multibrand",
    "SVC_Address":"1st Floor, B-18, M.C No. 432-R, Model Town, Ludhiana, Punjab-141002,",
    "Latitude":"30.88918541",
    "Longitude":"75.83937651",
    "Contact_Number":"0161-4650600 | 0161-4650600",
    "Customer_visiting_Timings":"10:00 AM - 06:00 PM"
  },

  {
    "Postal_Pincode":[{"zipcode":"110002,	110055,	110001,	110003,	110011,	110006,	110060,	110004,	110069,	110080,	110090,	110092,	110101,	110108,	110114,	110503,	201302,	110051,	110032,	110053,	110091,	110094,	110095,	110031,	110096,	110093,	110020,	110054,	110009,	110025,	110062,	110019,	110024,	110049,	110017,	110013,	110065,	110048,	110014,	110076,	110038,	110021,	110029,	110047,	110074,	110030,	110016,	110068,	110067,	110023,	110070,	110022,	110066,	110057,	110005,	110008,	110012,	110036,	110052,	110039,	110040,	110086,	110084,	110081,	110082,	110007,	110083,	110033,	110085,	110056,	110035,	110042,	110089,	110034,	110088,	110075,	110077,	110041,	110071,	110072,	110059,	110043,	110073,	110058,	110078,	110064,	110046,	110028,	110045,	110063,	110026,	110015,	110087,	110027,	110018,	110044"}],
    "State":"Delhi",
    "City":"Delhi",
    "Store_name":"F1 Info Solutions and Services - New Delhi",
    "SVC_Address":"L-108/109, 2nd Floor, Lajpat Nagar Part 2, New Delhi - 110024",
    "Latitude":"28.483",
    "Longitude":"77.09569",
    "Contact_Number":"011-41005851-52/54",
    "Customer_visiting_Timings":"10:00 AM - 06:00 PM"
  },  
];
const cityList = [{
  "State": "",
  "City": [],
}];

let serviceRequestButton = `<a href="https://boultaudio.my.salesforce-sites.com/support/" target="_blank" class="theme-btn">
  Register Service Request
</a>`;

let emptyServiceHTML = `<div class="no-service-centers">
  <p>Looks like there are no service centers around you. Please click on the link below to raise a service request.</p>
  ${serviceRequestButton}
</div>`;

let yesServiceHTML = `<div class="yes-service-centers">
  <p class="">Want to send your product directly to us instead? Click on the link below to raise a service request.</p>
  ${serviceRequestButton}
</div>`;

let above35ServiceHTML = `<div class="no-service-centers above-35-line">
  <p>Looks like service centers are a bit far from you. Please click on the link below to raise a service request.</p>
  ${serviceRequestButton}
</div>`;

function appendSericeCenters(i, arrLength) {
  let serviceHTML = `<div class="service-center-location" city_name="${i.City}" pincode="${i.Postal_Pincode[0].zipcode}" state="${i.State}">
    <div class="heading">
      <h3>${i.City}</h3>
      <address>
        <p class="store-name">${i.Store_name}</p>
        <p class="address">
          ${i.SVC_Address}
        </p>
      </address>
    </div>
    <div class="text">
      <div class="phone">
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="18" cy="18" r="18" fill="#46BFD6"/><g clip-path="url(#clip0_722_2136)"><path d="M12.6771 17.9568C12.0056 16.717 11.6814 15.7046 11.4859 14.6784C11.1967 13.1607 11.8584 11.6781 12.9546 10.7321C13.4179 10.3323 13.949 10.4689 14.223 10.9893L14.8415 12.1642C15.3317 13.0954 15.5768 13.561 15.5282 14.0547C15.4796 14.5483 15.149 14.9504 14.4879 15.7545L12.6771 17.9568ZM12.6771 17.9568C14.0363 20.4662 16.1694 22.7259 18.5421 24.1668M18.5421 24.1668C19.713 24.8778 20.6692 25.2211 21.6384 25.4281C23.0718 25.7343 24.472 25.0336 25.3654 23.873C25.743 23.3824 25.614 22.8201 25.1225 22.53L24.0129 21.8751C23.1334 21.356 22.6936 21.0965 22.2274 21.148C21.7612 21.1995 21.3815 21.5495 20.622 22.2495L18.5421 24.1668Z" stroke="white" stroke-width="1.5" stroke-linejoin="round"/></g><defs><clipPath id="clip0_722_2136"><rect width="17" height="18" fill="white" transform="translate(10 9)"/></clipPath></defs></svg>
        </svg>
        <a href="tel:${i.Contact_Number}">${i.Contact_Number}</a>
      </div>
      <div class="time">
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="18" cy="18" r="18" fill="#46BFD6"/><path d="M16.4102 11.6465V20.9641L23.8219 24.3524" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </svg>
        <span>${i.Customer_visiting_Timings}<br><span> Mon - Sat</span></span>
      </div>
      <div class="map">
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="18" cy="18" r="18" fill="#46BFD6"/><path d="M12.0465 11.1137L10.9631 11.7422C10.0911 12.248 9.65515 12.5009 9.41547 12.9217C9.17578 13.3424 9.17578 13.8548 9.17578 14.8795V22.0836C9.17578 23.43 9.17578 24.1032 9.47778 24.4778C9.67873 24.7272 9.96033 24.8948 10.2717 24.9503C10.7395 25.0338 11.3124 24.7015 12.458 24.0369C13.236 23.5856 13.9847 23.1169 14.9154 23.244C15.3387 23.3018 15.7425 23.5026 16.5501 23.9042L19.9153 25.5775C20.6432 25.9394 20.6499 25.9409 21.4593 25.9409H23.2934C24.9572 25.9409 25.7891 25.9409 26.306 25.4127C26.8228 24.8844 26.8228 24.0341 26.8228 22.3336V16.3864C26.8228 14.6859 26.8228 13.8356 26.306 13.3073C25.7891 12.779 24.9572 12.779 23.2934 12.779H21.4593C20.6499 12.779 20.6432 12.7775 19.9153 12.4155L16.9757 10.9539C15.7483 10.3436 15.1346 10.0384 14.4808 10.0596C13.827 10.0808 13.2335 10.4251 12.0465 11.1137Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.4688 10.0586L14.4687 22.8527" stroke="white" stroke-linecap="round" stroke-linejoin="round"/><path d="M20.6445 13.1465L20.6445 25.4994" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </svg>
        <span>
          <a href="https://www.google.com/maps?q=${i.Latitude},${i.Longitude}&amp;z=17&amp;hl=en" target="_blank">View Map</a>
        </span>
      </div>
    </div>
  </div>`;
  $('#service-centres-list').append(arrLength.length !== 0 ? serviceHTML : emptyServiceHTML);
}

$(document).ready(function () {
  const serviceCentresList = $('#service-centres-list');
  const pincodeInput = $('.pincode-input input');

  // Initially hide the service centers
  serviceCentresList.hide();

  let searchTimer;

  // Function to update service centers based on the input value
  const updateServiceCenters = function () {
    const inputVal = pincodeInput.val().trim().toLowerCase();

    // Clear the existing content
    serviceCentresList.empty();

    if (inputVal === "") {
      serviceCentresList.hide(); // Hide service centers when the input is empty
    } else {
      const filteredCenters = serviceCenters.filter((el) => {
        return el.Postal_Pincode.some((postal) => postal.zipcode.includes(inputVal));
      });

      if (filteredCenters.length === 0) {
        serviceCentresList.append(emptyServiceHTML); // Show emptyServiceHTML when no services are found
      } else {
        filteredCenters.forEach((element) => {
          appendSericeCenters(element, filteredCenters);
        });

        if (inputVal.length >= 6) {
          const farCount = filteredCenters.reduce((count, center) => {
            count += center.Postal_Pincode.some((el) => el.zipcode.includes(inputVal) && parseInt(el.distance) >= 35) ? 1 : 0;
            return count;
          }, 0);

          farCount > 0 && serviceCentresList.append(above35ServiceHTML);
          console.log(farCount);
        }

        serviceCentresList.append(yesServiceHTML); // Show yesServiceHTML when service centers are found
        serviceCentresList.show(); // Show service centers when there's input
      }
    }
  };

  // Attach the update function to the input event with a delay
  pincodeInput.on('input', function () {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(updateServiceCenters, 300);
  });
});
